import { useEffect, useState } from 'react';
import { fetchFilterDirectory } from '../services/dataQuality.api';

export function useFilterDirectory() {
  const [data, setData] = useState({
    operators: [],
    units: [],
    meters: [],
    evns: []        
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const res = await fetchFilterDirectory();
        if (mounted) setData(res);
      } catch (err) {
        if (mounted) setError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return { ...data, loading, error };
}
